import { SingleDataValue } from './SingleDataValue';
import FormatDate from '../../../Utils/Local/FormatDate';
import TranslateTag from '../../../Utils/Local/TranslateTag';
import { ParseColourTag } from './ReportColourParser';

const normalLines = (lines, reportPdf, data, totalPages, language) => {
    const state = normalLinesNoPositionSave(
        lines,
        reportPdf,
        data,
        totalPages,
        language
    );

    reportPdf.setCurrentLine(state.currentLine);
    reportPdf.setCurrentLinePosition(state.currentLinePosition);
};

const normalLinesNoPositionSave = (
    lines,
    reportPdf,
    data,
    totalPages,
    language
) => {
    let currentLine = reportPdf.getCurrentLine();
    let currentLinePosition = reportPdf.getCurrentLinePosition();

    for (const line of lines) {
        if (currentLine !== line.Line) {
            const fontSize =
                !line.FontSize || line.FontSize === 0 ? 11 : line.FontSize;
            reportPdf.setFontSize(fontSize);
            currentLinePosition += reportPdf.getLineHeight('Test') + 4;
        }
        singleLine(
            line,
            data,
            reportPdf,
            currentLinePosition,
            totalPages,
            language
        );

        currentLine = line.Line;
    }

    currentLinePosition += 7.5;

    return { currentLinePosition, currentLine };
};

const singleLine = (
    line,
    data,
    reportPdf,
    currentLinePos,
    totalPages,
    language
) => {
    if (line.FontSize && line.FontSize > 0) {
        reportPdf.setFontSize(line.FontSize);
    }

    if (line.Text) {
        reportPdf.text(line.Left, currentLinePos, line.Text);
    } else {
        if (line.Field) {
            let textToDisplay = SingleDataValue(line.Field, data);

            const colourTag = ParseColourTag(textToDisplay);

            if (colourTag) {
                reportPdf.setTextColor(colourTag.colour);
                textToDisplay = textToDisplay.replace(colourTag.text, '');
            }
            reportPdf.text(line.Left, currentLinePos, textToDisplay);
            reportPdf.setTextColor(0, 0, 0);
        } else {      
            if (line.Calc) {
                if (line.Calc.toLowerCase() === 'printeddate') {
                    reportPdf.text(
                        line.Left,
                        currentLinePos,
                        FormatDate(new Date())
                    );
                }
                if (line.Calc.toLowerCase() === 'pages') {
                    reportPdf.text(
                        line.Left,
                        currentLinePos,
                        TranslateTag('@GenPagA@', language) +
                            ' ' +
                            reportPdf.internal.getCurrentPageInfo().pageNumber +
                            ' ' +
                            TranslateTag('@GenOfA@', language) +
                            ' ' +
                            (totalPages ? totalPages.toString() : '0')
                    );
                }
            } else {
                reportPdf.text(line.Left, currentLinePos, 'NoDef');
            }
        }
    }
};

export {
    normalLines as NormalLines,
    singleLine as SingleLine,
    normalLinesNoPositionSave as NormalLinesNoPositionSave,
};
